exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mhd--page--header {\n  padding: 20px 30px; }\n  .mhd--page--header h1 {\n    display: inline-block; }\n  .mhd--page--header-actions {\n    float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Structure/SlideOutLayout.scss
// module id = 1315
// module chunks = 1